"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReactifySearchContext = exports.ReactifySearchContext = void 0;
const react_1 = __importDefault(require("react"));
exports.ReactifySearchContext = react_1.default.createContext(undefined);
const useReactifySearchContext = () => react_1.default.useContext(exports.ReactifySearchContext);
exports.useReactifySearchContext = useReactifySearchContext;
//# sourceMappingURL=useReactifySearchContext.js.map